import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider } from './components/UserContext';
import Home from './components/Home';
import Users from './components/Users';
import Members from './components/ClubMembers';
import Login from './login/Login';
import ResetPassword from './login/ResetPassword';
import RequestAccess from './login/RequestAccess';
import Dashboard from './components/Dashboard';
import Violations from './components/Violations';
import ViolationsDetails from './components/ViolationsDetails';
import Coverletters from './components/Coverletters';
import Workorders from './components/WorkOrders';
import WorkOrdersDetails from './components/WorkOrdersDetails'; 
import NewWorkOrder from './components/NewWorkOrder'; 
import FileManager from './components/FileManager'; 
import ClubMembers from './components/Memebers'; 
import MemberProfilePage from './components/MemberProfilePage';
import MembersPage from './components/MemberPage';
import ArchitecturalRequest from './components/ArchitecturalRequest';
import ArchitecturalRequestDetails from './components/ArchitecturalRequestDetails';
import Properties from './components/Properties';
import SystemPreferences from './components/SystemPreferences';
import Reports from './components/Reports';
import Profile from './components/MemberProfilePage';
import MemberViolationDetails from './components/OwnerDashboard/MemberViolationDetails';
import MemberWorkordersDetails from './components/OwnerDashboard/MemberWorkordersDetails';
import MemberArchitecturalRequests from './components/OwnerDashboard/MemberArchitecturalRequestDetails';
import UserProfile from './components/Userprofile';
import Integrations from './components/Integrations/Integrations';
import { ThemeProvider } from "./utils/ThemeContext";
import ThemeSettings from "./components/ThemeSettings";
import NotFound from './components/NotFound'; 
import ProtectedRoute from './components/ProtectedRoute';
import AccessDenied from './components/AccessDenied';
import GateSecurity from './components/GateSecurity';



function App() {
  return (
    <ThemeProvider>
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate replace to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/request-access" element={<RequestAccess />} />

          <Route path="/home" element={<Home />}>
  <Route
  index
  element={
    Number(localStorage.getItem("roleId")) === 3
      ? <Navigate to="/home/memberspage" replace />
      : <ProtectedRoute element={<Dashboard />} requiredPermission="view_dashboard" />
  }
/>
            <Route path="users" element={<ProtectedRoute element={<Users />} requiredPermission="view_users" />} />
            <Route path="coverletters" element={<ProtectedRoute element={<Coverletters />} requiredPermission="view_cover_letters" />} />
            
            <Route path="workorders" element={<ProtectedRoute element={<Workorders />} requiredPermission="view_work_orders" />}>
              <Route path="new" element={<NewWorkOrder />} />
              <Route path=":id" element={<WorkOrdersDetails />} />
            </Route>

            <Route path="members" element={<ProtectedRoute element={<Members />} requiredPermission="view_members" />} />
            <Route path="properties" element={<ProtectedRoute element={<Properties />} requiredPermission="view_properties" />}>
              <Route path=":id" element={<Profile />} />
            </Route>

            <Route path="architecturalrequest" element={<ProtectedRoute element={<ArchitecturalRequest />} requiredPermission="view_architectural_requests" />}>
              <Route path=":id" element={<ArchitecturalRequestDetails />} />
            </Route>

            <Route path="GateSecurity" element={<ProtectedRoute element={<GateSecurity />} requiredPermission="view_architectural_requests" />}>
             
            </Route>

            <Route path="filemanager" element={<ProtectedRoute element={<FileManager />} requiredPermission="view_file_manager" />} />
            <Route path="reports" element={<ProtectedRoute element={<Reports />} requiredPermission="view_reports" />} />
            <Route path="integrations" element={<ProtectedRoute element={<Integrations />} requiredPermission="view_reports" />} />
            
            <Route path="violations" element={<ProtectedRoute element={<Violations />} requiredPermission="view_violations" />}>
              <Route path=":id" element={<ViolationsDetails />} />
            </Route>

            <Route path="memberspage" element={<ProtectedRoute element={<MembersPage />} requiredPermission="access_owners_page" />} />
            <Route path="memberspage/violation/:id" element={<MemberViolationDetails />} />
            <Route path="memberspage/workorder/:id" element={<MemberWorkordersDetails />} />
            <Route path="memberspage/ArchitecturalRequests/:id" element={<MemberArchitecturalRequests />} />

            <Route path="clubmembers" element={<ProtectedRoute element={<ClubMembers />} requiredPermission="view_members" />} />
            <Route path="clubmembers/:ClubMemberCode" element={<MemberProfilePage />} />
            <Route path="system-preferences" element={<ProtectedRoute element={<SystemPreferences />} requiredPermission="access_system_preferences" />} />
            <Route path="user-profile" element={<UserProfile />} />
            <Route path="theme-settings" element={<ThemeSettings />} />
          </Route>

          <Route path="*" element={<NotFound />} />
          <Route path="/access-denied" element={<AccessDenied />} />

        </Routes>
      </Router>
    </UserProvider>
    </ThemeProvider>
  );
}

export default App;
